<template>
  <div>
    <div class="page-header">
      <h1>
        Product Coverage Export
      </h1>
    </div>
    <b-col md="5">
      <b-alert variant="success"
               dismissible
               fade
               :show="showSuccessfulFormSubmit"
               @dismissed="showSuccessfulFormSubmit=false">
        Thank you for submitting the request. You will receive an email with the CSV file shortly.
      </b-alert>
    </b-col>
    <b-col md="4" v-if="errors.length">
      <ErrorsContainer :errors="errors" />
    </b-col>
    <b-col md="4">
      <div class="alert alert-warning">
        This export generates data only for instant buy vendors.
      </div>
    </b-col>
    <b-form @submit.prevent="submitForm" inline>
      <label class="pr-2">Product:</label>
      <v-select v-model="selectedProduct"
                :options="activeProducts"
                class="mb-2 mr-sm-2 mb-sm-0 products-select">
      </v-select>
      <b-form-select v-model="selectedCountry"
                     :options="countriesListForSelect"
                     id="inline-form-input-country"
                     class="mb-2 mr-sm-2 mb-sm-0">
        <template slot="first">
          <option :value="null" disabled>Please choose a country</option>
        </template>
      </b-form-select>
      <b-button type="submit" variant="success">CSV</b-button>
    </b-form>
  </div>
</template>
<script>
import ProductsProvider from '@/services/ProductsProvider'
import ExportsProvider from '@/services/ExportsProvider'
import CountriesProvider from '@/services/CountriesProvider'
import ErrorsContainer from '@/components/ErrorsContainer'

export default {
  name: 'ProductCoverageExport',
  data () {
    return {
      activeProducts: [],
      selectedProduct: null,
      combinedDistrictCodes: [],
      errors: [],
      selectedCountry: null,
      showSuccessfulFormSubmit: false
    }
  },
  mounted () {
    this.applyActiveProducts()
  },
  methods: {
    applyActiveProducts () {
      ProductsProvider.activeProducts()
        .then((resp) => {
          this.activeProducts = resp.body.products.map((product) => {
            return { value: product.id, label: product.name }
          })
        })
    },
    submitForm () {
      if (this.selectedProduct === null) {
        this.errors.push('Please select a product.')
      } else if (this.selectedCountry === null) {
        this.errors.push('Please select a country.')
      } else {
        let params = {
          active: true,
          product_id: this.productId,
          country_code: this.selectedCountry,
          with_district_codes: true
        }
        return new Promise((resolve, reject) => {
          ExportsProvider.create('coverage_export', params)
            .then(resp => {
              this.showSuccessfulFormSubmit = true
              setTimeout(() => {
                this.showSuccessfulFormSubmit = false
              }, 10000)
              resolve(resp)
            }, (resp) => {
              this.errors.push(resp.body.error)
              resolve(resp)
            })
        })
      }
    }
  },
  computed: {
    countriesListForSelect () {
      let exceptList = this.combinedDistrictCodes.map(dc => dc.countryCode)
      return CountriesProvider.forSelect().filter(country => {
        return exceptList.indexOf(country.value) < 0
      })
    },
    productId () {
      let productId = []
      productId.push(this.selectedProduct.value)
      return productId
    }
  },
  components: {
    ErrorsContainer
  }
}
</script>

<style scoped>
.products-select {
  min-width: 185px;
}
</style>
